import { useReducer } from 'react';
import { getDefaultData } from '../../lib/getDefaultValues';
import qrData from '../QRFunctions/qrData';
import qrOptions from '../QRFunctions/qrOptions';

export const useQrStates = () => {
    const [qr_options, optionsDispatch] = useReducer((state, action) => {
        state = qrOptions(action, state);
        return state;
    }, null);

    const [qr_data, dataDispatch] = useReducer((state, action) => {
        if (action.type === 'set') {
            state = action.data;
        } else {
            state = qrData(action, state);
        };

        return state;
    }, {
        id: '',
        data: getDefaultData(),
    });

    return { qr_options, optionsDispatch, qr_data, dataDispatch };
};
